'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Util


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabbedNavigation = require('../../components/TabbedNavigation');

var _TabbedNavigation2 = _interopRequireDefault(_TabbedNavigation);

var _PlanStatusTitle = require('./plan/PlanStatusTitle');

var _PlanStatusTitle2 = _interopRequireDefault(_PlanStatusTitle);

var _userUtil = require('../userUtil');

require('./AccountModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB_UPGRADE = {
    title: 'Upgrade your plan',
    route: '/account/plan'
};

var TAB_REFER = {
    title: 'Refer a friend',
    route: '/account/refer'
};

var TABS = [TAB_UPGRADE, TAB_REFER];

var getLastPath = function getLastPath(routes) {
    return routes[routes.length - 1].path;
};

// this is a bit gross:
// only plan and refer modals should be shown within tab view,
// and only when the user isn't subscribed
var shouldUseTabs = function shouldUseTabs(_ref) {
    var routes = _ref.routes,
        currentUser = _ref.currentUser;

    if ((0, _userUtil.isSubscribed)(currentUser)) return false;

    var path = getLastPath(routes);
    if (path === 'plan' || path === 'refer') return true;

    return false;
};

var AccountModalTabbed = function AccountModalTabbed(props) {
    return _react2.default.createElement(
        'div',
        { className: 'AccountModal tabbed' },
        _react2.default.createElement(
            'div',
            { className: 'account-header' },
            _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(_PlanStatusTitle2.default, props)
            )
        ),
        _react2.default.createElement(
            _TabbedNavigation2.default,
            _extends({}, props, { tabs: TABS }),
            props.children
        )
    );
};

var AccountModalBox = function AccountModalBox(props) {
    return _react2.default.createElement(
        'div',
        { className: 'AccountModal' },
        props.children
    );
};

AccountModalTabbed.propTypes = AccountModalBox.propTypes = {
    children: _propTypes2.default.element
};

var AccountModal = function AccountModal(props) {
    if (shouldUseTabs(props)) return _react2.default.createElement(AccountModalTabbed, props);
    return _react2.default.createElement(AccountModalBox, props);
};

AccountModal.propTypes = {
    children: _propTypes2.default.element,
    currentUser: _propTypes2.default.object
};

exports.default = AccountModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/AccountModal.js
// module id = 2054
// module chunks = 0